import { isNetworkError } from '@/utils/is-network-error';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

/**
 * 런치패드 위저드 전용 QueryClient — MFMS `lib/query-client.ts` 이식본.
 *
 * MPMS 전역 QueryClient(providers/query-provider)는 모든 에러에 antd message를
 * 띄우는 글로벌 핸들러를 갖고 있어, sonner 토스트로 에러를 소화하는 런치패드
 * 화면과 겹치면 이중 토스트가 발생한다. 런치패드 라우트는 이 클라이언트를
 * 중첩 Provider로 사용해 MFMS와 동일한 에러 처리 동작을 유지한다.
 */

let networkToastId: string | number | undefined;

function handleNetworkError(error: Error) {
  if (isNetworkError(error) && !networkToastId) {
    networkToastId = toast.error('네트워크 오류가 발생했습니다.', {
      description: '인터넷 연결을 확인해주세요.',
      onDismiss: () => {
        networkToastId = undefined;
      },
      onAutoClose: () => {
        networkToastId = undefined;
      },
    });
  }
}

let mutationNetworkToastId: string | number | undefined;

function handleMutationNetworkError(error: Error) {
  if (isNetworkError(error) && !mutationNetworkToastId) {
    mutationNetworkToastId = toast.error('저장에 실패했습니다', {
      description: '잠시 후 다시 시도해 주세요.',
      onDismiss: () => {
        mutationNetworkToastId = undefined;
      },
      onAutoClose: () => {
        mutationNetworkToastId = undefined;
      },
    });
  }
}

export const launchpadQueryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: handleNetworkError,
  }),
  mutationCache: new MutationCache({
    onError: handleMutationNetworkError,
  }),
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 1000,
      refetchOnReconnect: false,
      networkMode: 'always',
    },
    mutations: {
      networkMode: 'always',
    },
  },
});
